import React, { useState } from "react";
import { Form, Button, Container, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import callingleads from "../../assets/images/associates_creation_format.csv";
import { FaFileDownload } from "react-icons/fa";
const API_URL = process.env.REACT_APP_API_URL;

function CreateAssociateByUploadingCSV() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);

  const getAuthToken = () => {
    return localStorage.getItem("token");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      Swal.fire({
        icon: "error",
        title: "No CSV File",
        text: "Please select a CSV file before submitting.",
      });
      return;
    }
    setLoading(true);
    try {
      const token = getAuthToken();
      if (!token) {
        Swal.fire({
          icon: "error",
          title: "Authentication Error",
          text: "Authentication token not found. Please log in.",
        });
        return;
      }

      const uploadData = new FormData();
      uploadData.append("associateCsv", file); // Changed from "associates" to "associateCsv"

      const response = await fetch(`${API_URL}/associate-import`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: uploadData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorData.message || "Failed to import associates.",
        });
        return;
      }

      const result = await response.json();

      if (result.status === "1") {
        // Check if any data was actually imported
        if (result.summary && result.summary.imported === 0) {
          Swal.fire({
            icon: "warning",
            title: "No Data Imported",
            text: "Sorry, no data was imported. Please check your CSV file or duplicate try again.",
            confirmButtonText: "OK"
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: `Successfully imported ${result.summary?.imported || 0} associates!`,
            confirmButtonText: "OK"
          });

          setFile(null);
          document.querySelector('input[type="file"]').value = "";

          setTimeout(() => {
            navigate("/all-associate-list");
          }, 2000);
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: result.message || "Something went wrong!",
          confirmButtonText: "OK"
        });
      }
    } catch (err) {
      console.error("Error importing associates:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message || "An unexpected error occurred.",
      });
    } finally {
      setLoading(false);
    }
  };

  // return (
  //   <div className="mt-2">
  //     <div className="row">
  //       <div className="col-md-12">
  //         <div className="card">
  //           <div className="card-header">
  //             <div className="d-flex flex-wrap-mobile gap-2 align-items-center justify-content-between">
  //               <div className="titlepage">
  //                 <h3>Create New Associate By Uploading CSV</h3>
  //               </div>

  //               <div className="d-flex justify-content-between">
  //                 <OverlayTrigger
  //                   placement="top"
  //                   overlay={<Tooltip>Download Create New Associate By Uploading CSV Format</Tooltip>}
  //                 >
  //                   <a href={callingleads}
  //                     className="btn btn-primary"
  //                     download="Associates Creation Format.csv"
  //                   >
  //                     Download CSV Format
  //                   </a>
  //                 </OverlayTrigger>
  //               </div>
  //             </div>
  //           </div>
  //           <div className="card-body">
  //             <Form onSubmit={handleSubmit}>
  //               <Form.Group className="mb-3">
  //                 <Form.Label>Select CSV File</Form.Label>
  //                 <Form.Control
  //                   type="file"
  //                   accept=".csv"
  //                   onChange={(e) => {
  //                     const selectedFile = e.target.files[0];
  //                     if (!selectedFile) return;

  //                     const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
  //                     if (fileExtension !== "csv") {
  //                       Swal.fire({
  //                         icon: "error",
  //                         title: "Invalid File",
  //                         text: "Only CSV files are allowed!",
  //                       });
  //                       e.target.value = null;
  //                       setFile(null);
  //                       return;
  //                     }
  //                     setFile(selectedFile);
  //                   }}
  //                 />
  //                 <Form.Text className="text-muted">
  //                   Only CSV files are allowed. Maximum file size: 10MB
  //                 </Form.Text>
  //               </Form.Group>

  //               {file && (
  //                 <div className="alert alert-info">
  //                   Selected file: <strong>{file.name}</strong>
  //                 </div>
  //               )}

  //               <div className="submitbutton">
  //                 <Button
  //                   type="submit"
  //                   className="submitbutton_design mt-2"
  //                   disabled={loading || !file}
  //                   variant="primary"
  //                 >
  //                   {loading ? (
  //                     <>
  //                       <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
  //                       Importing...
  //                     </>
  //                   ) : (
  //                     "Import Associates"
  //                   )}
  //                 </Button>
  //               </div>
  //             </Form>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );
return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "30px 24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          {/* 🎯 HEADER CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              padding: "20px 24px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "20px",
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                width: "52px",
                height: "52px",
                borderRadius: "14px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "24px",
                boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                flexShrink: 0,
              }}
            >
              📤
            </div>
            <div style={{ flex: 1, minWidth: "200px" }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: "800",
                  color: "#1e3a5f",
                  letterSpacing: "-0.5px",
                }}
              >
                Upload CSV — Create Associates
              </h1>
              <p
                style={{
                  margin: "2px 0 0",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: "500",
                }}
              >
                Bulk create associates via CSV file
              </p>
            </div>

            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip>
                  Download Create New Associate By Uploading CSV Format
                </Tooltip>
              }
            >
              <a
                href={callingleads}
                download="Associates Creation Format.csv"
                style={{
                  padding: "12px 24px",
                  borderRadius: "12px",
                  border: "none",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  color: "#ffffff",
                  fontSize: "14px",
                  fontWeight: "700",
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 8px 24px rgba(30, 87, 153, 0.3)",
                }}
              >
                <FaFileDownload /> Download Format
              </a>
            </OverlayTrigger>
          </div>

          {/* 🎯 MAIN CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "5px",
                background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div style={{ padding: "30px" }}>
              <Form onSubmit={handleSubmit}>
                {/* 🎯 CSV UPLOAD AREA */}
                <div
                  style={{
                    border: "2px dashed #cbd5e1",
                    borderRadius: "14px",
                    padding: "30px",
                    textAlign: "center",
                    background: "#f8fafc",
                    marginBottom: "20px",
                  }}
                >
                  <div style={{ fontSize: "40px", marginBottom: "10px" }}>
                    📄
                  </div>
                  <p
                    style={{
                      margin: "0 0 12px",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#1e3a5f",
                    }}
                  >
                    {file
                      ? `Selected: ${file.name}`
                      : "Choose a CSV file to upload"}
                  </p>
                  <input
                    type="file"
                    accept=".csv"
                    onChange={(e) => {
                      const selectedFile = e.target.files[0];
                      if (!selectedFile) return;

                      const fileExtension = selectedFile.name
                        .split(".")
                        .pop()
                        .toLowerCase();
                      if (fileExtension !== "csv") {
                        Swal.fire({
                          icon: "error",
                          title: "Invalid File",
                          text: "Only CSV files are allowed!",
                        });
                        e.target.value = null;
                        setFile(null);
                        return;
                      }
                      setFile(selectedFile);
                    }}
                    style={{
                      padding: "10px",
                      borderRadius: "10px",
                      border: "1.5px solid #e2e8f0",
                      background: "#ffffff",
                      cursor: "pointer",
                      width: "100%",
                      maxWidth: "400px",
                    }}
                  />
                  <p
                    style={{
                      margin: "12px 0 0",
                      fontSize: "12px",
                      color: "#94a3b8",
                    }}
                  >
                    Only CSV files are allowed. Maximum file size: 10MB
                  </p>
                </div>

                {file && (
                  <div
                    style={{
                      padding: "14px 18px",
                      borderRadius: "12px",
                      background: "#eff6ff",
                      border: "1.5px solid #bfdbfe",
                      color: "#1e3a5f",
                      fontSize: "13.5px",
                      fontWeight: "600",
                      marginBottom: "20px",
                    }}
                  >
                    ✅ Selected file: <strong>{file.name}</strong>
                  </div>
                )}

                {/* Submit Button */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    paddingTop: "20px",
                    borderTop: "1.5px dashed #e2e8f0",
                  }}
                >
                  <button
                    type="submit"
                    disabled={loading || !file}
                    style={{
                      padding: "13px 42px",
                      borderRadius: "12px",
                      border: "none",
                      background:
                        loading || !file
                          ? "#cbd5e1"
                          : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                      color: "#ffffff",
                      fontSize: "14.5px",
                      fontWeight: "800",
                      letterSpacing: "0.5px",
                      cursor:
                        loading || !file ? "not-allowed" : "pointer",
                      transition: "all 0.3s ease",
                      boxShadow:
                        loading || !file
                          ? "none"
                          : "0 8px 24px rgba(30, 87, 153, 0.3)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                      minWidth: "220px",
                    }}
                  >
                    {loading ? (
                      <>
                        <span
                          style={{
                            width: "16px",
                            height: "16px",
                            border: "2px solid rgba(255,255,255,0.3)",
                            borderTop: "2px solid #ffffff",
                            borderRadius: "50%",
                            display: "inline-block",
                            animation: "spin 0.8s linear infinite",
                          }}
                        />
                        Importing...
                      </>
                    ) : (
                      "Import Associates"
                    )}
                  </button>
                </div>

                {/* Footer Note */}
                <div
                  style={{
                    marginTop: "20px",
                    paddingTop: "20px",
                    borderTop: "1.5px dashed #e2e8f0",
                    textAlign: "center",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontSize: "12.5px",
                      color: "#94a3b8",
                      fontWeight: "500",
                    }}
                  >
                    📌 Download the CSV format above and fill it correctly
                    before uploading
                  </p>
                </div>
              </Form>
            </div>
          </div>

          {/* Footer Copyright */}
          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "12.5px",
              marginTop: "24px",
              fontWeight: "500",
            }}
          >
            © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
            Rights Reserved.
          </p>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
}



export default CreateAssociateByUploadingCSV;